import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import callApi from '../../../../helpers/apiCaller';
import config from '../../../../common/config';
import Cookies from 'universal-cookie';
import ButtonBKSystem from './ButtonBKSystem';
import AppsDropdown from './AppsDropdown';
import {
  selectCourses,
  selectSelectedCourseId,
  setSelectedCourseId
} from '../../../../components/CoursesStore';
import ChangePasswordModal from 'components/ChangePasswordModal/ChangePasswordModal';

const Topbar = () => {
  const dispatch = useDispatch();
  const courses = useSelector(selectCourses);
  const selectedCourseId = useSelector(selectSelectedCourseId);
  const [openChangePassword, setOpenChangePassword] = useState(false);

  var cookies = new Cookies();
  var accessToken = cookies.get('access_token');
  if (accessToken == null) {
    //login gv
    accessToken = window.localStorage.getItem('AccessToken');
  }
  if (accessToken == null) {
    // hs
    accessToken = '';
  }
  var header = { authorization: accessToken };

  const [username, setUsername] = useState('');
  const [className, setClassName] = useState('');
  const [fullname, setFullname] = useState('');
  //const updateProgressCurrent = useRef(0);
  const [updateProgressCurrent, setUpdateProgressCurrent] = useState(0);
  const [userType, setUserType] = useState('');
  const checkRole = useRef(false);
  const [checkTK, setCheckTK] = useState(0);
  const today = new Date();
  const userStore = cookies.get('user_store');
  const [anchorEl, setAnchorEl] = useState(null);
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  var checkProcess = 0;

  useEffect(() => {
    (async () => {
      var site_url =
        window.location.valueOf().pathname + window.location.valueOf().search;
      cookies.set('SiteUrl', site_url, { path: '/' });
      if (userStore == null) {
        const body1 = {};
        // get user
        const url = config.getRootURL() + '/gd/v3/user_infos';
        await callApi(url, 'GET', body1, header).then((response) => {
          if (!response) {
            config.hideLoader();
            return false;
          }

          setUsername(response.data.data.user.username);
          setFullname(response.data.data.user.fullname);
          setClassName(response.data.data.user.class?.title);

          //updateProgressCurrent.current = response.data.data.user.update_progress;
          setUpdateProgressCurrent(response.data.data.user.update_progress);
          checkProcess = response.data.data.user.update_progress;

          setUserType(response.data.data.user.user_logintype_code);
          cookies.set(
            'user_store',
            JSON.stringify(response.data.data.user).replace(/</g, '\\u003c'),
            { path: '/' }
          );
          config.AddDataIntoCache(
            'user_store',
            '/',
            JSON.stringify(response.data.data.user)
          );
          config.AddDataIntoCache('is_logged', '/', true);

          if (
            response.data.data.user.roles != null &&
            response.data.data.user.roles.student == true
          ) {
            setCheckTK(1);
          }
          if (
            response.data.data.user.roles != null &&
            response.data.data.user.roles.teacher == true
          ) {
            setCheckTK(2);
          }
          if (
            response.data.data.user.roles != null &&
            response.data.data.user.roles.school == true
          ) {
            setCheckTK(3);
          }
        });
      } else {
        setUsername(userStore.username);
        setClassName(userStore.class?.title);
        setFullname(userStore.fullname);
        if (
          (userStore != undefined || userStore != null) &&
          userStore.user_logintype_code != undefined
        ) {
          setUserType(userStore.user_logintype_code); //hcmedu
        }
        if (userStore.roles != null && userStore.roles.student == true) {
          checkRole.current = true;
          setCheckTK(1);
          // tạm ẩn chức năng này khi gọi đếm bài thi cần làm cur_status = 21
          //GetStudentExamsNotExam(5,0);

          // setInterval(() => {
          //   GetStudentExamsNotExam(1,0);
          // }, 10000);
        }
        if (userStore.roles != null && userStore.roles.teacher == true) {
          setCheckTK(2);
        }
        if (userStore.roles != null && userStore.roles.school == true) {
          setCheckTK(3);
        }
      }

      setInterval(() => {
        if (checkProcess == 2 || checkProcess == 4) {
          GetUserInfo(); // 10s call user_info
        } else {
          setUpdateProgressCurrent(0);
          checkProcess = 0;
        }
      }, 10000);

      (() => {
        const handleClickOutside = (event) => {
          const tooltipContainer = document.querySelector('.tooltip-container');
          if (tooltipContainer && !tooltipContainer.contains(event.target)) {
            setTooltipVisible(false);
          }
          if (
            userMenuRef.current &&
            !userMenuRef.current.contains(event.target)
          ) {
            setIsUserMenuOpen(false);
          }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      })();
    })();
  }, []);

  async function GetUserInfo() {
    const body1 = {};
    // get user
    const url = config.getRootURL() + '/gd/v3/user_infos';
    await callApi(url, 'GET', body1, header).then((response) => {
      if (!response) {
        config.hideLoader();
        return false;
      }

      setUsername(response.data.data.user.username);
      setFullname(response.data.data.user.fullname);
      setClassName(response.data.data.user.class?.title);

      //updateProgressCurrent = response.data.data.user.update_progress;
      setUpdateProgressCurrent(response.data.data.user.update_progress);
      checkProcess = response.data.data.user.update_progress;

      cookies.set(
        'user_store',
        JSON.stringify(response.data.data.user).replace(/</g, '\\u003c'),
        { path: '/' }
      );
      config.AddDataIntoCache(
        'user_store',
        '/',
        JSON.stringify(response.data.data.user)
      );
      config.AddDataIntoCache('is_logged', '/', true);
    });
  }

  const handleChange = (event) => {
    event.persist();
    if (event.target.name === 'top_course_id') {
      const newCourseId = event.target.value;
      dispatch(setSelectedCourseId(newCourseId));
      window.location.reload();
    }
  };

  const toggleTooltip = (e) => {
    setAnchorEl(e.currentTarget);
    setTooltipVisible((prev) => !prev);
  };

  return (
    <div className="navbar grid grid-8 md:grid-4">
      <div style={{ display: 'ruby' }}>
        {
          // <a href="#">
          //   <img
          //     src={
          //       process.env.REACT_APP_STATIC_URL +
          //       'content/assets/images/icon-user.png'
          //     }
          //     alt=""
          //     className="logo"
          //   />
          // </a>
        }
        <a href="#" className="nav-link menu-toggle">
          <span className="icon-menu" />
        </a>

        <div className="nav-date">
          Ngày {today.getDate()} tháng {today.getMonth() + 1} năm{' '}
          {today.getFullYear()}
        </div>
      </div>

      <ul className="navbar-nav nav-right span-7 md:span-3">
        <li className="nav-item">
          <div className="nav-select nav-select-desktop">
            <select
              name="top_course_id"
              id="top_course_id"
              onChange={handleChange}
              value={selectedCourseId || ''}>
              {courses.map((course, num) => (
                <option key={course.id} value={course.id}>
                  Năm học {course.name} - {parseInt(course.name) + 1}{' '}
                </option>
              ))}
            </select>
            <span className="icon-down-chevron" />
          </div>
          <div className="nav-select nav-select-mobile">
            <select
              name="top_course_id"
              id="top_course_id_mobile"
              onChange={handleChange}
              value={selectedCourseId || ''}>
              {courses.map((course, num) => (
                <option key={course.id} value={course.id}>
                  {course.name} - {parseInt(course.name) + 1}
                </option>
              ))}
            </select>
            <span className="icon-down-chevron" />
          </div>
        </li>
        <li className="nav-item">
          <ButtonBKSystem
            isTooltipVisible={isTooltipVisible}
            anchorEl={anchorEl}
            toggleTooltip={toggleTooltip}
          />
        </li>
        <li
          className="nav-item nav-user"
          style={{ display: 'contents' }}
          ref={userMenuRef}>
          <a
            href="#"
            className="nav-link grid grid-5"
            onClick={(e) => {
              e.preventDefault();
              setIsUserMenuOpen((prev) => !prev);
            }}>
            {
              <img
                src={
                  process.env.REACT_APP_STATIC_URL +
                  'content/assets/images/icon-user.png'
                }
                alt=""
              />
            }
            <span className="lg:span-3">
              <strong>{fullname == '' ? username : fullname}</strong>
              <p style={{ textAlign: 'start', marginLeft: '12px' }}>
                {checkTK == 1
                  ? `Học sinh - ${className}`
                  : checkTK == 2
                    ? 'Giáo viên'
                    : checkTK == 3
                      ? 'Admin trường'
                      : ''}
              </p>
            </span>
            <span className="icon-user icon-down-chevron" />
          </a>
          <div
            className={`dropdown-content dropdown-sm${isUserMenuOpen ? ' active' : ''}`}>
            <ul className="linklist">
              {
                userType == 'hcmedu' ? (
                  ''
                ) : (
                  <li>
                    <a href="/thong-tin-tai-khoan">Thông tin cá nhân</a>
                  </li>
                )
                //userType == "hcmedu" ? "" : <li><a href="/dang-ky-thong-tin">Thông tin cá nhân</a></li>
              }
              {userType != 'hcmedu' && (
                <li>
                  <a onClick={() => setOpenChangePassword(true)}>
                    Đổi mật khẩu
                  </a>
                </li>
              )}
              <li>
                <a href="/thoat">Thoát</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      {isTooltipVisible && <AppsDropdown anchorEl={anchorEl} />}
      {openChangePassword && (
        <ChangePasswordModal
          open={openChangePassword}
          onClose={() => setOpenChangePassword(false)}
        />
      )}
    </div>
  );
};

export default Topbar;
